import AndroidIcon from '@/shared/components/icons/professions/android-icon';
import BackendIcon from '@/shared/components/icons/professions/backend-icon';
import CPlusPlusIcon from '@/shared/components/icons/professions/c-plus-plus-icon';
import DataAnalyticIcon from '@/shared/components/icons/professions/data-analytic-icon';
import { DesignIcon } from '@/shared/components/icons/professions/design-icon';
import { DevIcon } from '@/shared/components/icons/professions/dev-icon';
import IosIcon from '@/shared/components/icons/professions/ios-icon';
import UxUiIcon from '@/shared/components/icons/professions/ux-ui-icon';
export interface Section {
  title?: string;
  content: Array<string> | string;
}

/** Full case story (sections from i18n cases-list, review image path here). */
export interface CaseInfo {
  sections: Array<Section>;
  review: string;
}
export interface StudentCase {
  Icon?: any;
  name: string;
  description: string;
  href: string;
  cta: string;
  className: string;
  /** Image path only; section copy is in public/locales (cases-list.json, cases.N.infoSections). */
  info?: {
    review: string;
  };
}
export const STUDENTS_CASES: Array<StudentCase> = [{
  Icon: BackendIcon,
  name: 'Артемий, Backend developer',
  description: 'Оффер в Дубай на 8500$ в месяц за 4 месяца занятий.',
  href: '/cases/backend-dev-offer-uae',
  cta: 'Читать кейс',
  className: 'lg:row-start-1 lg:row-end-4 lg:col-start-2 lg:col-end-3',
  info: {
    review: '/images/reviews/artemiy-be.webp'
  }
}, {
  Icon: DataAnalyticIcon,
  name: 'Кристина, Data analyst',
  description: 'Оффер в США через 5 занятий. Мы рассмотрели вопросы на собеседованиях и профессиональную лексику.',
  href: '/cases/data-analyst-offer-usa',
  cta: 'Читать кейс',
  className: 'lg:row-start-1 lg:row-end-3 lg:col-start-1 lg:col-end-2',
  info: {
    review: '/images/reviews/kristina-analyst.webp'
  }
}, {
  Icon: CPlusPlusIcon,
  name: 'Салават, Senior software engineer, C++',
  description: 'Подготовка к собеседованию за 1,5 месяца.',
  href: '/cases/senior-dev-interview-prep',
  cta: 'Читать кейс',
  className: 'lg:row-start-3 lg:row-end-4 lg:col-start-1 lg:col-end-2',
  info: {
    review: '/images/reviews/salavat-c-plus.webp'
  }
}, {
  Icon: IosIcon,
  name: 'Ксения, iOS developer',
  description: 'Оффер в Литовскую компанию через 2,5 месяца занятий.',
  href: '/cases/ios-dev-offer-europe',
  cta: 'Читать кейс',
  className: 'lg:row-start-1 lg:row-end-2 lg:col-start-3 lg:col-end-3',
  info: {
    review: '/images/reviews/kseniya-ios.webp'
  }
}, {
  Icon: AndroidIcon,
  name: 'Александр, Android developer',
  description: 'Получение оффера спустя 3 месяца занятий. Отточили скорость речи, вокабуляр, самопрезентацию. Улучшили LinkedIn и CV.',
  href: '/cases/android-dev-offer-after-3-months',
  cta: 'Читать кейс',
  className: 'lg:row-start-2 lg:row-end-4 lg:col-start-3 lg:col-end-3',
  info: {
    review: '/images/reviews/aleksandr-android.webp'
  }
}, {
  Icon: UxUiIcon,
  name: 'Мария, UX Researcher',
  description: 'Оффер в международном стартапе спустя 2 месяца подготовки.',
  href: '/cases/international-startup-offer',
  cta: 'Читать кейс',
  className: 'lg:row-start-4 lg:row-end-7 lg:col-start-1 lg:col-end-2',
  info: {
    review: '/images/reviews/mariya-ux.webp'
  }
}, {
  Icon: DesignIcon,
  name: 'Дмитрий, Senior Product Designer',
  description: 'Оффер в американский стартап спустя 2,5 месяца занятий.',
  href: '/cases/usa-startup-offer',
  cta: 'Читать кейс',
  className: 'lg:row-start-4 lg:row-end-5 lg:col-start-2 lg:col-end-2',
  info: {
    review: '/images/reviews/dmitriy-prod-designer.webp'
  }
}, {
  Icon: DevIcon,
  name: 'Павел, Software Development',
  description: 'Оффер в Германии через 3 месяца занятий.',
  href: '/cases/germany-job-offer',
  cta: 'Читать кейс',
  className: 'lg:row-start-5 lg:row-end-7 lg:col-start-2 lg:col-end-2',
  info: {
    review: '/images/reviews/pavel-dev.webp'
  }
}, {
  Icon: DevIcon,
  name: 'Дмитрий, Software Developer',
  description: 'Подготовка к собеседованию на английском за 3 месяца занятий.',
  href: '/cases/international-company-interview-preparation',
  cta: 'Читать кейс',
  className: 'lg:row-start-4 lg:row-end-6 lg:col-start-3 lg:col-end-3',
  info: {
    review: '/images/reviews/dmitriy-dev.webp'
  }
}, {
  Icon: DevIcon,
  name: 'Гузель, Software Developer',
  description: 'С А2 до В1 за 6 месяцев + получение офера в международную компанию.',
  href: '/cases/international-company-offer',
  cta: 'Читать кейс',
  className: 'lg:row-start-6 lg:row-end-7 lg:col-start-3 lg:col-end-3',
  info: {
    review: '/images/reviews/guzel-dev.webp'
  }
}];